module.exports = __webpack_public_path__ + "static/media/hei.aaf2ce63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hei.jpg
// module id = 5746
// module chunks = 0